import React from "react";
import PropTypes from "prop-types";

import "./Chip.scss";

const Chip = ({ label, onDelete }) => (
	<div className="chip">
		<span>{label}</span>
		<button
			type="button"
			onClick={onDelete}
		>
			&times;
		</button>
	</div>
);

Chip.propTypes = {
	label: PropTypes.string.isRequired,
	onDelete: PropTypes.func.isRequired,
};

export default Chip;
